import { useEffect, useState } from 'react'
import { getDashboardCommercialDiscussionClientsV2, getDashboardHomeHeaderV2, type DashboardHomeHeaderV2Dto } from '@/lib/api/v2/dashboard'

export function useDashboardHomeHeaderV2(params?: { state?: 'no_quote' | 'quote_draft' | 'quote_issued' }) {
  const [data, setData] = useState<DashboardHomeHeaderV2Dto | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const [commercialDiscussionCounts, setCommercialDiscussionCounts] = useState<{
    all: number
    noQuote: number
    quoteDraft: number
    quoteIssued: number
  } | null>(null)
  const [reloadKey, setReloadKey] = useState(0)

  useEffect(() => {
    let cancelled = false
    /* eslint-disable react-hooks/set-state-in-effect */
    setIsLoading(true)
    setError(null)
    /* eslint-enable react-hooks/set-state-in-effect */

    Promise.all([getDashboardHomeHeaderV2(), getDashboardCommercialDiscussionClientsV2({ state: params?.state })])
      .then(([header, commercialDiscussion]) => {
        if (cancelled) return
        setCommercialDiscussionCounts(commercialDiscussion.counts)
        setData({ ...header, commercialDiscussionClients: commercialDiscussion.items || [] })
      })
      .catch((e) => {
        if (cancelled) return
        setError(e)
        setData(null)
        setCommercialDiscussionCounts(null)
      })
      .finally(() => {
        if (cancelled) return
        setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [params?.state, reloadKey])

  const refetch = () => setReloadKey((k) => k + 1)

  return { data, isLoading, error, refetch, commercialDiscussionCounts }
}
